import Container from "./Container";

export default function Footer() {
  return (
    <footer className="border-t bg-white">
      <Container className="py-8 grid gap-6 md:grid-cols-3 text-sm text-slate-600">
        <div>
          <div className="font-semibold text-slate-900 mb-2">Know Thalassemia</div>
          <p>This is a student project website. Information is for awareness only and not medical advice.</p>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-2">Quick Links</div>
          <ul className="space-y-1">
            <li><a className="hover:text-rose-600" href="/about">About</a></li>
            <li><a className="hover:text-rose-600" href="/testing-locator">Testing Locator</a></li>
            <li><a className="hover:text-rose-600" href="/resources">Resources</a></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-2">Contact</div>
          <a className="text-rose-600" href="mailto:knowthalassemia.project@gmail.com">
            knowthalassemia.project@gmail.com
          </a>
        </div>
      </Container>
      <div className="border-t">
        <Container className="py-4 text-xs text-slate-500">
          © {new Date().getFullYear()} Know Thalassemia — Student Awareness Initiative
        </Container>
      </div>
    </footer>
  );
}
